import type {
  IAdapterConfig,
  MiddlewareConfigClass
} from '@care-portals/api-interfaces';

const config = {
  vsdigital: {
    label: 'VSDigital Pharmacy',
    functions: {
      CreateOrder: {
        middlewareHandler: 'vsdigital',
        version: 1,
        label: 'Create Order',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      /**
       * VSDigital has no webhooks, so status only advances when this is called. The status-polling
       * cron (`apps/middleware/src/vsdigital/lambda-cron.ts`) drives it on a schedule; it's also
       * callable as a manual workflow step.
       */
      RetrieveOrderStatus: {
        middlewareHandler: 'vsdigital',
        version: 1,
        label: 'Retrieve Order Status',
        pipelines: ['order'],
        passPayload: true,
        params: []
      }
    }
  }
} as const;

export const VSDigitalConfig: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type VSDigitalFunctionConfiguration = MiddlewareConfigClass<
  typeof config.vsdigital.functions
>;
